(() => {
  'use strict';
  const root = document.body.dataset.outletRoot || '/';
  const themeId = document.body.dataset.outletTheme;
  if (!themeId) return;
  const outletUrl = path => {
    const url = new URL(path, location.origin);
    url.searchParams.set('view', 'pst-outlet');
    url.searchParams.set('preview_theme_id', themeId);
    return url.pathname + url.search + url.hash;
  };
  const updateLinks = () => {
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && (url.pathname === root + 'cart' || url.pathname.startsWith(root + 'products/'))) {
        const target = outletUrl(url);
        if (link.getAttribute('href') !== target) link.setAttribute('href', target);
      }
    });
  };
  updateLinks();
  new MutationObserver(updateLinks).observe(document.body, {childList:true,subtree:true});
  const navigateColor = event => {
    const link = event.target.closest?.('a.opt-label-link-tiv, a.custom-opt-label');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith(root + 'products/')) return;
    const size = document.querySelector('.option-selector-tiv[data-option="Size"] input[type="radio"]:checked, .option-selector[data-option="Size"] input[type="radio"]:checked')?.value.toLowerCase();
    const variant = size && link.getAttribute('data-variant-' + size);
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
    else url.searchParams.delete('variant');
    link.setAttribute('href', outletUrl(url));
    event.stopImmediatePropagation();
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (link.target && link.target !== '_self')) return;
    event.preventDefault();
    location.assign(link.href);
  };
  document.addEventListener('click', navigateColor, true);
  document.addEventListener('auxclick', navigateColor, true);
  document.addEventListener('on:variant:change', () => {
    history.replaceState(history.state, '', outletUrl(location.href));
  });
  const updateCount = async () => {
    try {
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(node => {node.textContent = cart.item_count;});
    } catch {}
  };
  window.addEventListener('pageshow', updateCount);
  document.addEventListener('theme:cartchanged', updateCount);
})();
